import React, { ReactElement, useState } from 'react';
import { Form, Select } from 'antd';
import { isEmpty } from 'lodash';

import { Nullable } from 'types';
import useBreedVarieties from 'pricing/hooks/useBreedVarieties/useBreedVarieties';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled: boolean;
}

function FilterFieldPuppyVarieties(props: Props): ReactElement {
  const { disabled } = props;
  const [breedId, setBreedId] = useState<Nullable<number>>(null);
  const { breedVarieties } = useBreedVarieties(breedId);

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) => {
        if (prevValues.breed_id !== curValues.breed_id) {
          setBreedId(curValues.breed_id);
        }
        return prevValues.breed_id !== curValues.breed_id;
      }}
    >
      {(form) => {
        const breedId = form.getFieldValue('breed_id');

        return (
          <Form.Item name="variety_ids" style={{ width: 200, marginBottom: 0 }}>
            <Select
              disabled={!breedId || isEmpty(breedVarieties) || disabled}
              data-testid={testId.filterFieldPuppyVarieties}
              placeholder="Variety"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {breedVarieties.map((variety) => (
                <Select.Option
                  data-testid={testId.filterFieldPuppyVarietyOption}
                  key={variety.id}
                  value={variety.id}
                >
                  {variety.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
}

export default FilterFieldPuppyVarieties;
